import React from 'react';
import styled from 'styled-components';
import Icon from '../../app/common/components/Icon';
import ICONS from '../../app/common/constants/icons';
import { TranslationHelpers } from '../../i18n/translationHelpers';

interface IProps {
    serviceName: string;
    migrationDate: string;
}

const Banner = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background-color: #ebf7fe;
    border-radius: 8px;
    padding: 12px;
    margin: 16px 10px 10px 10px;
    color: #006497;
    font-size: 1rem;
    line-height: 1.5;
`;

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-top: 2px;
`;

const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const CardSharingDisclaimer = ({ serviceName, migrationDate }: IProps) => {
    return (
        <Banner>
            <IconWrapper>
                <Icon icon={ICONS.INFO_FILLED} size="16" viewBoxMax="16" fill="#006497" />
            </IconWrapper>
            <TextWrapper>
                <span>
                    {TranslationHelpers.getFormattedMessage(
                        'payment.card_sharing.disclaimer.line1',
                        { serviceName },
                    )}
                </span>
                <span>
                    {TranslationHelpers.getFormattedMessage(
                        'payment.card_sharing.disclaimer.line2',
                        { serviceName, migrationDate },
                    )}
                </span>
            </TextWrapper>
        </Banner>
    );
};

export default CardSharingDisclaimer;
